export const TYPE_PUBLICATION = {
  BOOK: 'BOOK',
  BOOK_AGGREGATION: 'BOOK_AGGREGATION',
  FINISHED: 'FINISHED',
  INACTIVE: 'INACTIVE',
}
